import * as yup from "yup";

export const caseFiltersSchema = yup.object().shape({
  status: yup.string(),
  dentalClinicName: yup.string(),
  dentistName: yup.string(),
  patientName: yup.string(),
  caseNo: yup.string(),
  userRole: yup.string(),
  userFullName: yup.string(),
  showTerminatedCases: yup.boolean(),
});
